import { StyleSheet } from 'react-native';
import { $green } from '../../generalStyles';

export default StyleSheet.create({
    icon: {
        height: 18,
        width: 18
    }
});